import * as React from 'react';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { useIntl, useSelector, statusUninit, statusLoading, statusWarning, statusFailed } from '@grandvisionhq/state';
import '../../state/actions.js';
import { PRESCRIPTION_STEP_FORM_ERROR_ID } from '../../state/constants.js';
import '../../state/add-to-cart/selectors.js';
import '../../state/bundles/selectors.js';
import '../../state/bundles/reducer.js';
import { getSelectedFrame, getPrescription, getIsPrescriptionFormStepValid } from '../../state/configurator/selectors.js';
import '../../state/configurator/reducer.js';
import '../../state/products/selectors.js';
import '../../state/products/reducer.js';
import { PrescriptionFormStep } from './PrescriptionFormStep.js';

const PrescriptionFormStepContainer = ()=>{
    const { hasAttemptedNextStep  } = useConfiguratorContext();
    const [errorMessageKey, setErrorMessageKey] = React.useState(null);
    const { getLabel  } = useIntl();
    const frame = useSelector(getSelectedFrame);
    const prescription = useSelector(getPrescription);
    const isPrescriptionFormStepValid = useSelector(getIsPrescriptionFormStepValid);
    React.useEffect(()=>{
        if (hasAttemptedNextStep && !isPrescriptionFormStepValid) {
            setErrorMessageKey('products.glasses.prescription.form.validationError');
            return;
        }
        setErrorMessageKey(null);
    }, [
        hasAttemptedNextStep,
        isPrescriptionFormStepValid
    ]);
    const isLoading = !prescription || statusUninit(prescription) || statusLoading(prescription);
    const isFailed = !frame || statusWarning(prescription) || statusFailed(prescription);
    return /*#__PURE__*/ React.createElement(PrescriptionFormStep, {
        isLoading: isLoading,
        isFailed: isFailed,
        errorMessage: errorMessageKey ? getLabel(errorMessageKey) : '',
        errorMessageId: PRESCRIPTION_STEP_FORM_ERROR_ID
    });
};

export { PrescriptionFormStepContainer };
//# sourceMappingURL=PrescriptionFormStepContainer.js.map
